export const NO_VALUE = '-';
export const MAX_MONEY_VALUE = 100_000_000;
